import {OrderListConfig} from "../models/OrderListConfig";
import {
    isCompletedOrderIncludeUnfilledUpdate,
    isCompletedOrderListColumnsUpdate, isCompletedOrderListIncludeExternalUpdate, isCompletedOrderOnlyMineUpdate,
    isWorkingOrderListColumnsUpdate, isWorkingOrderListIncludeExternalUpdate, isWorkingOrderListOnlyMineUpdate,
    isWorkingOrderListSortingUpdate,
    OrderListConfigUpdate
} from "../models/OrderListConfigUpdate";

export function applyConfigUpdate(previous: OrderListConfig, update: OrderListConfigUpdate): OrderListConfig {
    if (isWorkingOrderListSortingUpdate(update)) {
        return {
            ...previous,
            working: {
                ...previous?.working,
                order: update.sorting
            }
        };
    } else if (isWorkingOrderListColumnsUpdate(update)) {
        return {
            ...previous,
            working: {
                ...previous?.working,
                columns: update.columns
            }
        };
    } else if (isCompletedOrderListColumnsUpdate(update)) {
        return {
            ...previous,
            completed: {
                ...previous?.completed,
                columns: update.columns
            }
        };
    } else if (isCompletedOrderIncludeUnfilledUpdate(update)) {
        return {
            ...previous,
            completed: {
                ...previous?.completed,
                includeUnfilled: !previous?.completed.includeUnfilled
            }
        };
    } else if (isWorkingOrderListOnlyMineUpdate(update)) {
        return {
            ...previous,
            working: {
                ...previous?.working,
                onlyMine: !previous?.working?.onlyMine
            }
        };
    } else if (isCompletedOrderOnlyMineUpdate(update)) {
        return {
            ...previous,
            completed: {
                ...previous?.completed,
                onlyMine: !previous?.completed?.onlyMine
            }
        };
    } else if (isWorkingOrderListIncludeExternalUpdate(update)) {
        return {
            ...previous,
            working: {
                ...previous?.working,
                includeExternal: !previous?.working?.includeExternal
            }
        };
    } else if (isCompletedOrderListIncludeExternalUpdate(update)) {
        return {
            ...previous,
            completed: {
                ...previous?.completed,
                includeExternal: !previous?.completed?.includeExternal
            }
        };
    } else {
        return previous;
    }
}
